import React, {forwardRef} from 'react';
import ReactInputMask from 'react-input-mask';
import {PhoneOutlined} from '@ant-design/icons';
import {Input} from 'antd';

export default forwardRef((props, ref) => {
  return (
    <ReactInputMask {...props}>
      {(inputProps) => (
        <Input
          size='large'
          prefix={<PhoneOutlined style={{fontSize: 20, transform: 'rotateY(180deg)'}} />}
          {...inputProps}
          ref={ref}
          disabled={props.disabled ? props.disabled : null}
        />
      )}
    </ReactInputMask>
  );
});
